import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { OffreCompleteRequise } from '@/components/OffreCompleteRequise';
import { ACCUEIL_FORMULE_RETENUE, estFormuleRetenue, routeOuverteFormuleRetenue } from '@/lib/formule';

/**
 * Posée autour de chaque page protégée. Pour un compte en formule Retenue :
 * le tableau de bord (où mènent la connexion, l'inscription et la racine) renvoie
 * vers les retenues, et une rubrique de l'offre complète n'est pas montée du tout.
 */
export function GardeFormule({ children }: { children: ReactNode }): ReactNode {
    const { user } = useAuth();
    const { pathname } = useLocation();

    if (!estFormuleRetenue(user) || routeOuverteFormuleRetenue(pathname)) return children;
    if (pathname === '/dashboard') return <Navigate to={ACCUEIL_FORMULE_RETENUE} replace />;
    return <OffreCompleteRequise />;
}
